export default __webpack_public_path__ + "static/media/Montserrat-Regular.94bb495f.ttf";